import { render, staticRenderFns } from "./problem.vue?vue&type=template&id=53d9fe10&scoped=true"
import script from "./problem.vue?vue&type=script&lang=js"
export * from "./problem.vue?vue&type=script&lang=js"
import style0 from "./problem.vue?vue&type=style&index=0&id=53d9fe10&prod&lang=stylus&scoped=true"
import style1 from "./problem.vue?vue&type=style&index=1&id=53d9fe10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d9fe10",
  null
  
)

export default component.exports